import { formatNumber } from '../helpers/utils';

const ChartTable = ({ chartdata }) => {

    if ((chartdata === undefined) || (chartdata === null) || (!Array.isArray(chartdata))) {
        return null;
    }

    // console.log("\n\n\n");
    // console.log("==========================");
    // console.log(chartdata);
    // console.log("==========================");
    // console.log("\n\n\n");

    return (
        <div className='chart-table-container'>
            <table className='chart-table'>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>All</th>
                        <th>Peers</th>
                        <th>You</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        chartdata.map((row, i) => {
                            return (
                                <tr key={i}>
                                    <td>{row.text}</td>
                                    <td>{formatNumber(row.all, 1)}</td>
                                    <td>{formatNumber(row.peers, 1)}</td>
                                    <td>{formatNumber(row.advisor, 1)}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ChartTable
